import React from 'react';
export function HeroSection() {
  return <div className="bg-[#9B0137] py-16 px-4" data-id="element-1368">
      <div className="max-w-4xl mx-auto text-center" data-id="element-1369">
        <div className="bg-white/10 p-8 rounded-2xl backdrop-blur-sm inline-block mb-6" data-id="element-1370">
          <img src="https://drwzpk38qkpfb.cloudfront.net/www.peakedm.com/uploaded/images/LOGOS/Breton%20Machine%20Tools%20Logo.png" alt="Breton Machine Tools Logo" className="block h-24 md:h-32 w-auto mx-auto" data-id="element-1371" />
        </div>
        <h1 className="text-4xl md:text-5xl font-bold text-white tracking-tight" data-id="element-1372">
          Breton Machine Tools
        </h1>
      </div>
    </div>;
}